import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { OrganizationApi } from '../../api/organization/organization.api';
import { FeatureFlagName, PlatformApi } from '../../api/platform/platform.api';

interface Params {
  organizationId?: string | null;
  name: FeatureFlagName;
}

export const useFetchFeatureFlag = ({
  organizationId,
  name,
}: Params): UseQueryResult<
  {
    isEnabled: boolean;
  },
  unknown
> => {
  return useQuery({
    queryKey: ['feature-flag', { _id: organizationId, name }],
    queryFn: async () => {
      let isEnabled = false;

      const platformFeatureFlag = await PlatformApi.getFeatureFlag({
        name,
      });

      isEnabled = platformFeatureFlag.isEnabled;
      if (!isEnabled && organizationId) {
        const organizationFeatureFlag = await OrganizationApi.getFeatureFlag({
          organizationId,
          name,
        });

        isEnabled = organizationFeatureFlag.isEnabled;
      }

      return {
        isEnabled,
      };
    },
    /* 1 min */
    staleTime: 1000 * 60,
  });
};
